export interface FsLprRawFleetReadCoordinates {
  x: number;
  y: number;
  width: number;
  height: number;
}
